export const productConstants = {
    PRODUCT_LIST_FAIL: 'PRODUCT_LIST_FAIL',
    PRODUCT_LIST_SUCCESS: 'PRODUCT_LIST_SUCCESS',
    PRODUCT_LIST_RESET: 'PRODUCT_LIST_RESET'
};
  